import { gql } from '@apollo/client';

export const HIERARCHIES_QUERY = gql`
  query PartnerHierarchies($pager: PagerInput!, $filters: PartnerHierarchyFiltersInput) {
    partnerHierarchies(pager: $pager, filters: $filters) {
      total
      values {
        partnerHierarchyId
        hierarchyName
        hierarchyCode
        isActive
        details {
            partnerHierarchyDetailId
            partnerHierarchyId
            category
            partnerId
            parentDetailId
            partnerName
        }
      }
    }
  }
`;

export const PARTNERS_SEARCH = gql`
  query partnersSearch($search: String) {
    partnersSearch(search: $search) {
      id
      uniqueId
      partnerName
    }
  }
`;

export const GET_PARTNER_HIERARCHY = gql`
  query getPartnerHierarchy($partnerHierarchyId: Int!) {
    getPartnerHierarchy(partnerHierarchyId: $partnerHierarchyId) {
      partnerHierarchyId
      hierarchyCode
      hierarchyName
      isActive
    }
  }
`;

export const GET_PARTNER_HIERARCHY_DETAILS = gql`
  query getPartnerHierarchy($partnerHierarchyId: Int!) {
    getPartnerHierarchy(partnerHierarchyId: $partnerHierarchyId) {
      partnerHierarchyId
      detailsTree {
        data {
            partnerHierarchyDetailId
            partnerHierarchyId
            category
            partnerId
            parentDetailId
            path
            partnerName
        }
        children
      }
    }
  }
`;